import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withRouter } from 'react-router-dom';
import qs from 'query-string';
import generatePath from '~settings/routing';
import { Tooltip, Button, Modal, Icon, message } from 'antd';
import { getItem } from '~helpers/storage';
import { Hosts } from '~helpers/environments';
import BreadCrumbs from '~components/bread-crumbs';
import showElementByAuth from '~helpers/auth';
import { platformEntity, entityAction } from '~constants';
import { authUrl } from '~settings/endpoints';
import { fetch } from '~helpers/graphql';
import * as queries from '~settings/queries';

class PropertyHeader extends React.Component {
  constructor() {
    super();
    this.state = {
      visibleDeleteModal: false,
      showTooltip: false,
      tooltipType: null,
    };
  }

  handleCheckDeleteProperty = propertyId => {
    const { t } = this.props;
    fetch(
      queries.checkDeleteProperty({
        propertyId,
      }),
    )
      .then(res => {
        if (res?.checkDeleteProperty?.success) {
          this.setState({ showTooltip: false });
        } else {
          this.setState({ showTooltip: true, tooltipType: res?.checkDeleteProperty?.msg });
        }
      })
      .catch(() => {
        message.error(t('cms.properties.edit.toast.error'));
      });
  };

  componentDidMount() {
    const propertyId = qs.parse(this.props?.history?.location?.search)?.propertyId;

    if (propertyId && this.props.showDelete) {
      this.handleCheckDeleteProperty(propertyId);
    }
  }

  generatePropertyUrl = property => {
    const path = `${
      property.city && property.city.country && property.city.country.slug
        ? property.city.country.slug
        : ''
    }/${property.city && property.city.slug ? property.city.slug : ''}/p/${property.slug}`;

    return `${Hosts.propertyUrl}${path}`;
  };

  getFilters = () => {
    const filters = getItem('cms_properties_list_filters');
    const result = {};
    if (filters) {
      Object.keys(filters).forEach(key => {
        if (filters[key]) {
          result[key] = filters[key];
        }
      });
    }
    if (filters && filters.pageNumber && filters.pageNumber === 1) {
      delete result.pageNumber;
    }
    if (filters && filters.pageSize && filters.pageSize === 10) {
      delete result.pageSize;
    }

    return result;
  };

  redirectToEditPage = () => {
    let path = '';
    if (this.props.type === 'homepage') {
      path = generatePath('properties', {}, this.getFilters());
    }

    if (
      [
        'edit',
        'commission',
        'record',
        'deposit-and-fees',
        'reference-and-contact',
        'terms',
      ].indexOf(this.props.type) !== -1
    ) {
      path = generatePath(
        'property.homepage',
        { propertySlug: this.props.property.slug },
        { propertyId: this.props.property.id },
      );
    }

    return path;
  };

  handlePreview = () => {
    this.props.handlePreview(res => {
      if (res && res.slug && res.city.slug && res.city.country && res.city.country.slug) {
        this.previewForm.action = authUrl(
          `/${res.city.country.slug}/${res.city.slug}/p/${res.slug}?preview=yes&update_cache=yes`,
        );
        document.getElementById('item__data').value = JSON.stringify({
          property: res,
        });
        this.previewForm.submit();
      }

      return false;
    });
  };

  handleDeleteProperty = () => {
    const { t, property, history } = this.props;
    fetch(
      queries.deleteProperty({
        propertyId: property?.id,
      }),
    )
      .then(res => {
        if (res?.deleteProperty?.success) {
          history.replace(generatePath('properties'));
        } else {
          message.error(t('cms.properties.edit.toast.error'));
        }
        this.setState({ visibleDeleteModal: false });
      })
      .catch(() => {
        message.error(t('cms.properties.edit.toast.error'));
        this.setState({ visibleDeleteModal: false });
      });
  };

  render() {
    const { t, property, type } = this.props;
    return (
      <div className="property-header">
        <If condition={property}>
          <BreadCrumbs
            t={t}
            type={type}
            propertySlug={property.slug}
            propertyId={property.id}
            getFilters={this.getFilters}
          />
          <div className="property-header__header-info">
            <h2 className="property-header__property-name">
              <Tooltip
                title={
                  this.props.property.status === 'PUBLISHED'
                    ? t('cms.edit.header.label.view_on_student')
                    : t('cms.header.property_name.unpublished.tips')
                }
              >
                <Choose>
                  <When condition={property.status === 'PUBLISHED'}>
                    <a
                      className="property-header__text"
                      target="_blank"
                      href={this.generatePropertyUrl(property)}
                      rel="noopener noreferrer"
                    >
                      {property.name}
                      <span className="property-header__underline" />
                    </a>
                  </When>
                  <Otherwise>
                    <span className="property-header__text">{property.name}</span>
                  </Otherwise>
                </Choose>
              </Tooltip>
              <If condition={property.id}>
                <span className="property-header__property-id">
                  {t('cms.header.property_id.text')}
                  {JSON.parse(window.atob(property.id)).id}
                </span>
              </If>
              <div
                className={classNames(
                  'property-header__property-status',
                  `property-header__property-status--${property.status}`,
                )}
              >
                {t(
                  `cms.property_card.status.tag.${
                    property.status ? property.status.toLowerCase() : ''
                  }`,
                )}
              </div>
            </h2>
          </div>
          <div className="property-edit__btns">
            <If
              condition={
                qs.parse(this.props?.history?.location?.search)?.propertyId && this.props.showDelete
              }
            >
              <Tooltip
                placement="bottomRight"
                arrowPointAtCenter
                title={
                  this.state.showTooltip ? (
                    this.state.tooltipType === 'PROPERTY_IS_PUBLISHED' ? (
                      <span>
                        {t('cms.property_management.delete.published.tooltip')}
                        <b>{t('cms.table.value.published')}</b>
                      </span>
                    ) : (
                      <span>
                        {t('cms.property_management.delete.ongoing_past.tooltip')}
                        <b>{t('cms.property_management.delete.ongoing_past.desc')}</b>
                      </span>
                    )
                  ) : null
                }
              >
                <div
                  className={classNames(
                    'property-edit__btns__prim property-header__delete-btn',
                    this.state.showTooltip && 'property-header__delete-btn__disabled',
                  )}
                  onClick={() => {
                    if (!this.state.showTooltip) {
                      this.setState({ visibleDeleteModal: true });
                    }
                  }}
                >
                  {t('cms.form.button.delete')}
                </div>
              </Tooltip>
            </If>
            <If condition={type === 'change-log-listing-management'}>
              <Button
                size="large"
                type="primary"
                onClick={this.props.handleOpenFilterModal}
                className="property-edit__btns__prim property-header__btn"
              >
                {t('cms.properties.edit.btn.filter')}
              </Button>
            </If>
            <If
              condition={
                type === 'reference-and-contact' &&
                showElementByAuth(platformEntity.PROPERTIES_PROPERTIES, entityAction.UPDATE)
              }
            >
              <Button
                size="large"
                type="primary"
                onClick={this.props.handleSave}
                className="property-edit__btns__prim property-header__btn"
                loading={this.props.isFetchingSave}
              >
                {t('cms.properties.edit.btn.save')}
              </Button>
            </If>
          </div>
        </If>
        <Modal
          visible={this.state.visibleDeleteModal}
          width={416}
          okText={t('cms.form.button.delete')}
          className="delete-modal-wrapper"
          centered
          closable={false}
          footer={[
            <Button
              key="back"
              style={{ height: 32 }}
              onClick={() => {
                this.setState({ visibleDeleteModal: false });
              }}
            >
              {t('cms.billing.transfer.cancel.btn')}
            </Button>,
            <Button
              key="submit"
              type="danger"
              style={{ height: 32, marginLeft: 8, fontWeight: 600 }}
              onClick={this.handleDeleteProperty}
            >
              {t('cms.form.button.delete')}
            </Button>,
          ]}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Icon type="exclamation-circle" className="delete-modal-icon" />
            <span className="delete-modal-desc">
              {t('cms.property_management.delete.modal.tip')}
            </span>
          </div>
        </Modal>
      </div>
    );
  }
}

PropertyHeader.propTypes = {
  t: PropTypes.func.isRequired,
  property: PropTypes.object,
  showedWarningType: PropTypes.string,
  type: PropTypes.string,
  warningType: PropTypes.object,
  renderWarning: PropTypes.func,
  showWarning: PropTypes.bool,
  isFetchingSave: PropTypes.bool,
  handleSave: PropTypes.func,
  handleReview: PropTypes.func,
  handlePreview: PropTypes.func,
  isShowSaveButton: PropTypes.bool,
  handleOpenFilterModal: PropTypes.func,
  showDelete: PropTypes.bool,
};

PropertyHeader.defaultProps = {
  t: () => {},
  property: {},
  showedWarningType: '',
  type: '',
  warningType: {},
  renderWarning: () => {},
  showWarning: false,
  isFetchingSave: false,
  handleSave: () => {},
  handleReview: () => {},
  handlePreview: () => {},
  isShowSaveButton: false,
  handleOpenFilterModal: () => {},
  showDelete: false,
};

export default withRouter(PropertyHeader);
